// template file for injecting okta secrets from build
export const okta = {
  clientId: '0oa15y6pzs5a7Bnga0h8',
};
